const NUMERIC_SEGMENT = /^\d+$/;

export const slugify = (value?: string): string =>
  (value || "")
    .toString()
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(new RegExp("[\\u0300-\\u036f]", "g"), "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export interface RouteSection {
  area: string;
  section: string;
}

export const getRouteSection = (pathname?: string): RouteSection => {
  const segments = (pathname || "")
    .split("/")
    .filter((segment) => segment !== "" && !NUMERIC_SEGMENT.test(segment));

  const area = segments[0] || "page";
  const section = segments[segments.length - 1] || area;

  return { area, section };
};

export const buildTestId = (...parts: (string | undefined)[]): string => {
  const tokens: string[] = [];
  parts
    .filter((part): part is string => !!part)
    .forEach((part) => {
      if (tokens[tokens.length - 1] !== part) tokens.push(part);
    });
  return tokens.join("-");
};
